import { AcceptanceStatus, KYCWorkflowFileItemRes } from '@dealstack/shared/lib/generated';
import { KycApprovalStatus } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/types';

// Derive the Forms-step overall status from the attached forms (the same source as the count pills)
// rather than raw kycFiles — otherwise an attached-but-unsubmitted form (no kycFile) makes
// getKycStatusByFileType return null and the whole step wrongly renders a dash.
export const overallFormStatus = (files: KYCWorkflowFileItemRes[]): KycApprovalStatus => {
	if (!files.length) {
		return null;
	}
	if (
		files.some(
			(f) =>
				f.status === AcceptanceStatus.REJECTED || f.status === AcceptanceStatus.REREQUESTED
		)
	) {
		return AcceptanceStatus.REJECTED;
	}
	if (files.every((f) => f.status === AcceptanceStatus.APPROVED)) {
		return AcceptanceStatus.APPROVED;
	}
	return AcceptanceStatus.PENDING;
};
